import React, { useEffect, useState } from "react";
import { api } from "../../utils/axios";
import { MDBSpinner } from "mdb-react-ui-kit";
import jalaali from "jalaali-js";
import { toast } from "react-toastify";
import {
	Clock,
	CloseSquare,
	Document,
	DocumentDownload,
	InfoCircle,
	ProfileTick,
	TickSquare,
	Timer,
	Trash,
	UserEdit,
} from "iconsax-react";
import { useSelector } from "react-redux";
import TaskActionConfirmModal from "../../components/tasks/TaskActionConfirmModal.tsx";

function TaskDetails({
	tasks,
	selectedTask,
	onTaskDeleted,
	onTaskUpdated,
	onBack,
}) {
	const [task, setTask] = useState(null);
	const [loading, setLoading] = useState(false);
	const [downloadingFile, setDownloadingFile] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showActionModal, setShowActionModal] = useState(null);
	const [actionsLoading, setActionsLoading] = useState(false);
	const userData = useSelector((state) => state.user.data);

	useEffect(() => {
		if (selectedTask) {
			setLoading(true);

			const foundTask = tasks.find((t) => t.id === selectedTask);

			setTask(foundTask); // Set the task state directly from the response
			setLoading(false);

			setLoading(false);
		}
	}, [selectedTask, tasks]);

	const handleCompleteTask = () => {
		setLoading(true);
		api
			.patch(
				`/task/${task.id}/toggle_done`,
				{},
				{
					headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
				},
			)
			.then((res) => {
				setTask((prevTask) => ({ ...prevTask, is_done: !prevTask.is_done }));
				setLoading(false);
				toast.success("وضعیت تسک با موفقیت تغییر کرد");

				onTaskUpdated(selectedTask);
			})
			.catch((error) => {
				setLoading(false);
				toast.error("خطا در تغییر وضعیت تسک");
			});
	};

	const handleDeleteTask = () => {
		setLoading(true);

		api
			.post(
				"/delete_task",
				{ task_id: selectedTask },
				{
					headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
				},
			)
			.then((res) => {
				toast.success("تسک با موفقیت حذف شد");
				onTaskDeleted(selectedTask);
				setLoading(false);
				// Refresh the page
			})
			.catch((err) => {
				toast.error("خطا در حذف تسک");
				setLoading(false);
			});
	};

	const handleApproveTask = () => {
		setShowActionModal("approve");
	};

	const handleRejectTask = () => {
		setShowActionModal("reject");
	};

	// Handle file download
	const handleFileDownload = async () => {
		if (!task?.file) {
			toast.error("فایل پیوستی وجود ندارد");
			return;
		}
		setDownloadingFile(true);
		try {
			// Download directly from the file URL
			const response = await fetch(task.file);

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			// Get the file blob
			const blob = await response.blob();

			// Create a download link
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;

			// Extract filename from the file path or use a default name
			const fileName = task.file.split("/").pop() || "task_file";
			link.setAttribute("download", fileName);

			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);

			toast.success("فایل با موفقیت دانلود شد");
		} catch (error) {
			// Fallback: Open file URL directly in new tab
			if (task.file) {
				window.open(task.file, "_blank");
				toast.info("فایل در تب جدید باز شد");
			} else {
				toast.error("خطا در دانلود فایل");
			}
		} finally {
			setDownloadingFile(false);
		}
	};

	// Get file icon based on type
	const getFileIcon = (filePath) => {
		if (!filePath) return "📎";
		const extension = filePath.split(".").pop()?.toLowerCase();
		if (["jpg", "jpeg", "png", "gif", "bmp"].includes(extension)) return "🖼️";
		if (extension === "pdf") return "📄";
		if (["doc", "docx"].includes(extension)) return "📝";
		if (["xls", "xlsx"].includes(extension)) return "📊";
		if (extension === "txt") return "📄";
		return "📎";
	};

	// Get file name from path
	const getFileName = (filePath) => {
		if (!filePath) return "";
		return filePath.split("/").pop() || "فایل پیوست";
	};

	// Helper to convert English digits to Persian
	const toPersianNumber = (n) =>
		n?.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

	// Format deadline as yyyy/mm/dd in Persian
	const formatDeadlinePersian = (deadline) => {
		if (!deadline) return "نامشخص";
		const date = new Date(deadline);
		if (isNaN(date.getTime())) return "نامشخص";
		const j = jalaali.toJalaali(date);
		return `${toPersianNumber(j.jy)}/${toPersianNumber(j.jm)}/${toPersianNumber(j.jd)}`;
	};

	return (
		<>
			{showActionModal && (
				<TaskActionConfirmModal
					task_id={task?.id}
					requestLoading={actionsLoading}
					setRequestLoading={setActionsLoading}
					action={showActionModal}
					setAction={setShowActionModal}
				/>
			)}
			{loading ? (
				<div className="d-flex justify-content-center align-items-center w-100 h-100">
					<MDBSpinner color="primary" size="lg">
						<span className="visually-hidden">Loading...</span>
					</MDBSpinner>
				</div>
			) : selectedTask ? (
				<>
					<div
						className={`taskdetails-figma-card${showDeleteModal || showActionModal ? " taskdetails-blur" : ""}`}
					>
						<div className="taskdetails-title">{task?.title}</div>
						<div className="taskdetails-meta gap-2">
							<div className={"tw-flex tw-flex-row tw-gap-1"}>
								<UserEdit size={16} variant="Linear" />
								تعریف کننده: {task?.assigner?.fname} {task?.assigner?.lname}
							</div>
							<div className={"tw-flex tw-flex-row tw-gap-1"}>
								<ProfileTick size={18} color="#7A7E9D" />
								انجام دهنده: {task?.assigned_user?.fname}{" "}
								{task?.assigned_user?.lname}
							</div>
							<div className={"tw-flex tw-flex-row tw-gap-1"}>
								<Timer size={18} color="#7A7E9D" />
								ددلاین: {formatDeadlinePersian(task?.deadline)}
							</div>
						</div>
						<div
							className="taskdetails-desc-label"
							style={{
								display: "flex",
								alignItems: "center",
								gap: "6px",
								color: "#7A7A7A",
								fontWeight: 500,
								fontSize: "14px",
							}}
						>
							<InfoCircle size={18} color="#7A7E9D" style={{ marginLeft: 4 }} />
							توضیحات تسک:
						</div>
						<p
							className="taskdetails-desc h-full"
							style={{
								whiteSpace: "pre-line",
								fontSize: "15px",
								color: "#7A7A7A",
								textAlign: "right",
								lineHeight: "2.1",
							}}
						>
							{task?.description}
						</p>
						{/* File Attachment Section */}
						{task?.file && (
							<div className="taskdetails-file-section">
								<div
									className="taskdetails-file-label"
									style={{
										display: "flex",
										alignItems: "center",
										gap: "6px",
										color: "#7A7A7A",
										fontWeight: 500,
										fontSize: "14px",
										marginTop: "1rem",
									}}
								>
									<Document
										size={18}
										color="#7A7E9D"
										style={{ marginLeft: 4 }}
									/>
									فایل پیوست:
								</div>
								<div className="taskdetails-file-info">
									<div className="taskdetails-file-preview">
										<span className="taskdetails-file-icon">
											{getFileIcon(task.file)}
										</span>
										<div className="taskdetails-file-details">
											<div className="taskdetails-file-name">
												{getFileName(task.file)}
											</div>
											<div className="taskdetails-file-path">{task.file}</div>
										</div>
										<button
											className="taskdetails-download-btn"
											onClick={handleFileDownload}
											disabled={downloadingFile}
										>
											{downloadingFile ? (
												<MDBSpinner size="sm" color="#fff" />
											) : (
												<DocumentDownload size={18} color="#fff" />
											)}
											{downloadingFile ? "در حال دانلود..." : "دانلود"}
										</button>
									</div>
								</div>
							</div>
						)}
						{task?.note ? (
							<div className={"tw-w-full"}>
								<label className={"tw-text-gray-900 tw-text-base tw-font-bold"}>
									یادداشت:
								</label>
								<p className={"tw-text-gray-500"}>{task?.note}</p>
							</div>
						) : (
							<></>
						)}
						<div className="taskdetails-actions tw-max-w-4xl mx-auto">
							{(userData?.user?.uid === task?.assigner?.uid ||
								userData?.user?.is_leader) && (
								<button
									className="taskdetails-delete-btn"
									onClick={() => setShowDeleteModal(true)}
								>
									<Trash size={22} color="#fff" variant="Linear" />
									حذف تسک
								</button>
							)}
							{task?.pending ? (
								userData?.user?.uid === task?.assigner?.uid ? (
									<div className={"tw-flex tw-flex-row tw-gap-1"}>
										<button
											className="taskdetails-done-btn"
											onClick={handleApproveTask}
										>
											<TickSquare size={22} color="#36B37E" variant="Linear" />
											تایید
										</button>
										<button
											className="taskdetails-actions-btn hover:tw-bg-red-50 tw-text-red-600  tw-border-red-600"
											onClick={handleRejectTask}
										>
											<CloseSquare size={22} color="#dc2626" variant="Linear" />
											رد
										</button>
									</div>
								) : (
									<div className="taskdetails-pending">
										<Clock size={22} color="#b39e36" variant="Linear" />
										تسک در انتظار تایید است
									</div>
								)
							) : !task?.is_done ? (
								<button
									className="taskdetails-done-btn"
									onClick={handleCompleteTask}
								>
									<TickSquare size={22} color="#36B37E" variant="Linear" />
									انجام دادن تسک
								</button>
							) : (
								<></>
							)}
						</div>
					</div>
					{/* Delete Confirmation Modal - moved outside the blurred card */}
					{showDeleteModal && (
						<div className="taskdetails-modal-overlay">
							<div className="taskdetails-modal">
								<button
									className="taskdetails-modal-close"
									onClick={() => setShowDeleteModal(false)}
								>
									&times;
								</button>
								<div className="taskdetails-modal-icon">
									<InfoCircle size={38} color="#DE350B" variant="Bold" />
								</div>
								<div className="taskdetails-modal-message">
									آیا از حذف کردن این تسک اطمینان دارید؟ در صورت تایید، تمامی
									اطلاعات این تسک پاک خواهند شد
								</div>
								<div className="taskdetails-modal-actions">
									<button
										className="taskdetails-modal-delete-btn"
										onClick={() => {
											setShowDeleteModal(false);
											handleDeleteTask();
										}}
									>
										<Trash size={20} color="#fff" variant="Linear" /> حذف تسک
									</button>
									<button
										className="taskdetails-modal-cancel-btn"
										onClick={() => setShowDeleteModal(false)}
									>
										انصراف
									</button>
								</div>
							</div>
						</div>
					)}
				</>
			) : (
				""
			)}
		</>
	);
}

export default TaskDetails;
